export const BRAND = 'Brand';
//# sourceMappingURL=brand.js.map